import React, { useContext } from 'react';

import { type AppConfigProviderState } from './types';

const error = new Error('AppConfigProvider is not found in higher components');

const defaultState: AppConfigProviderState = {
	addFlag: () => {
		throw error;
	},
	push: () => {
		throw error;
	},
	replace: () => {
		throw error;
	},
	history: undefined,
	contextSpaPaths: [],
	contextEntryPoint: '',
	docTitle: {},
	appName: '',
	productName: '',
	env: undefined,
	cloudId: '',
	isJiraAvailable: false,
	productFeatureFlags: {},
	orgId: undefined,
};

const AppConfigContext = React.createContext(defaultState);

export const useAppConfig = () => {
	return useContext(AppConfigContext);
};

export default AppConfigContext;
